import InputText from '@/components/ext/input-text/input-text.vue'
import Datepicker from '@/components/ext/datepicker/datepicker.vue'
import Dropdown from '@/components/ext/dropdown/dropdown.vue'
import Button from '@/components/ext/button/button.vue'
import moment from 'moment/moment'
import {EventBus} from '@/services/EventBus'

const data = {
    en: {
        date: {
            regex: /^\s*(1[012]|0?[1-9])\.(3[01]|[12][0-9]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'MM.DD.YYYY',
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm',
        },
    },
    ru: {
        date: {
            regex: /^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:19|20)\d{2})\s*$/,
            format: 'DD.MM.YYYY',
        },
        time: {
            regex: /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/,
            format: 'HH:mm',
        },
    },
}

export default {
    name: 'datetime',
    inject: ['$validator'],
    data() {
        return {
            control: {
                date: null,
                time: null,
            },
        }
    },
    props: {
        value: {
            type: String,
        },
        name: {
            type: String,
            required: true,
        },
        lang: {
            type: String,
            default: 'en',
        },
        format: {
            type: String,
            default: '',
        },
        error: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        control: {
            deep: true,
            handler(control) {
                const date = moment(control.date, this.data.date.format, true)
                const time = moment(control.time, this.data.time.format, true)

                if (date.isValid() && time.isValid()) {
                    const diff = time.diff(time.clone().startOf('day')) / 1000
                    const datetime = date.add(diff, 'seconds')
                    this.$emit('input', datetime.format(this.format))
                    this.$emit('error', false)
                } else {
                    this.$emit('error', true)
                }
            }
        },
        value: {
            immediate: true,
            handler(value) {
                this.setControl(value)
            }
        },
        lang() {
            this.setControl(this.value)
        }
    },
    computed: {
        data() {
            return data[this.lang]
        },
    },
    methods: {
        setControl(value) {
            if (value) {
                this.control.date = moment(value, this.format, true).format(this.data.date.format)
                this.control.time = moment(value, this.format, true).format(this.data.time.format)
            }
        },
        closePicker(){
            EventBus.$emit('root-click')
        }
    },
    components: {
        InputText,
        Datepicker,
        Dropdown,
        'v-button': Button
    },
}



// WEBPACK FOOTER //
// ./src/components/ext/datetime/datetime.js